const LANGUAGE_LABELS = {EN: 'English', FR: 'French'};

/**
 * Select options for help-flow categories or features ("topics").
 *
 * Each exists once per language: "Deposits" (EN) and "Dépôts" (FR) are
 * separate ids, and a ticket belongs to the one in its own language. With a
 * language filter, list only that language; without one, list both and suffix
 * each with its language so the agent can pick each one they want. There's no
 * link between a topic and its translation, so we don't try to pair them.
 */
export const topicOptions = (items = [], language) => {
  const lang = language && language !== 'ALL' ? language : null;
  return items
    .filter(item => !lang || item.language === lang)
    .map(item => ({
      value: item.id,
      label: lang
        ? item.name
        : `${item.name} · ${LANGUAGE_LABELS[item.language] || item.language}`,
    }));
};

/**
 * Drop selected ids that are no longer on offer (after the language or the
 * chosen topics change), so the request never carries a hidden selection.
 * Keeps everything while the list hasn't loaded yet.
 */
export const keepOffered = (ids = [], options) =>
  options ? ids.filter(id => options.some(o => o.value === id)) : ids;
